import { useFlagr } from 'api/flagr';
import { Report } from 'types/report';
import { ENV } from '../../constants';

enum FLAG_TYPES {
  ACCOUNT = 'account',
  REPORT = 'report',
  CANDIDATE_EMAIL = 'candidateEmail',
}

function useGetFlag(
  flagKey: string,
  id: string | undefined,
  type: string,
  otherContext?: any,
) {
  const context = {
    locationHost: window.location.host,
    ...otherContext,
  };

  return useFlagr({
    context,
    id: flagKey,
    entity: { id, type },
    fallbackVariant: 'off',
  });
}

export function useGetFlagByCandidateEmail(
  flagKey: string,
  email: string | undefined,
) {
  const context = {
    candidateEmail: email,
  };
  return useGetFlag(flagKey, email, FLAG_TYPES.CANDIDATE_EMAIL, context);
}

export function useGetFlagByReport(
  flagKey: string,
  report: Report | undefined,
) {
  return useGetFlag(flagKey, report?.id, FLAG_TYPES.REPORT);
}

export function useGetFlagByReportAccount(
  flagKey: string,
  report: Report | undefined,
) {
  const account = report?.account;
  const context = {
    account_id: account?.id,
    account_uri: account?.uriName,
    env: ENV,
  };
  return useGetFlag(flagKey, account?.id, FLAG_TYPES.ACCOUNT, context);
}
